// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"afbb455f","455":"52f8ddcd","977":"5bfd9466"}[chunkId] + ".chunk.js";
};